module.exports = __webpack_public_path__ + "img/hs1.29638a8e.png";